{{each list}}
<div class="dynamin-list-block _userContent">
    {{if noAvatorLink}}
    <div class="dynamin-head">
        <img src="{{$value.user.avatar}}" alt="{{$value.user.real_name}}">
    </div>
    {{else}}
    <a href="/user/index?uid={{$value.uid}}">
        <div class="dynamin-head">
            <img src="{{$value.user.avatar}}" alt="{{$value.user.real_name}}">
        </div>
    </a>
    {{/if}}
    <div class="dynamin-content">
        <p class="dynamin-nikeName">
            <stong>{{$value.user.real_name}}</stong>
        </p>
        <p class="dynamin-info">
            <span>{{$value.user.career}}</span>·<span>{{$value.ctime}}</span>
        </p>
        <div class="dynamin-title _msgText">
            <p class="_msgWords" data-id="{{$value.topic_info.length > 0 && $value.topic_info[0].id}}">{{@ $value.dealContent}}</p>
            <span class="_lookFullDymContent hide-content-btn" style="display:none">查看全部</span>
        </div>
        <p class="dynamin-type-box">
            <i class="dynamin-type">{{$value.issue_name && $value.issue_name[0]}}</i>
            {{if $value.group_name}}
            <i class="dynamin-type dynamin-type-active">{{$value.group_name}}</i>
            {{/if}}
        </p>

        {{if $value.content_type == '3'}}
            {{if $value.pic_list && $value.pic_list.origin && $value.pic_list.origin.length > 0 }}
            {{set imgList = $value.pic_list.origin}}
            {{set thumbList = $value.pic_list.thumb}}
            {{set len = imgList.length}}
                <div class="dynamin-imgs {{if len > 1 }} {{if len === 2 ||len === 4 }} dynamin-imgs-double {{else}} {{/if}} {{else}} dynamin-imgs1 {{/if}}">
                    {{each thumbList}}
                    <img class="_smallImg" data-index="{{ $index }}" src="{{$value}}" data-ori-src="{{ imgList[ $index ] }}" alt="">
                    {{/each}}
                </div>
                <!--微博图片样式-->
                <div class="W-image-box">
                    <ul class="fun-bar">
                        <li class="_retract"><i class="icon iconfont icon-shouqi1"></i>收起</li>
                        <!--<li><i class="icon iconfont icon-sousuo1"></i>查看大图</li> -->
                        <li class="_turnRound" data-type="left"><i class="icon iconfont icon-shuaxinzuo"></i>向左旋转</li>
                        <li class="_turnRound" data-type="right"><i class="icon iconfont icon-shuaxin"></i>向右旋转</li>
                    </ul>
                    <div class="bImage-list">
                        <div class="bigimage">
                            <img src="{{ imgList[0] }}" alt="" class="_activeImgSrc">
                        </div>
                        <div class="toggle-area prev _prevBtn"></div>
                        <div class="toggle-area zoomout _retract"></div>
                        <div class="toggle-area next _nextBtn"></div>
                    </div>
                    {{if len > 1 }}
                    <ul class="sImage-list">
                        {{each thumbList}}
                        <li><a href="javascript:;" class="_smallImgList"><img src="{{ imgList[ $index ] }}"></a></li>
                        {{/each}}
                    </ul>
                    {{/if}}
                </div>
                <!--微博图片样式end-->
            {{/if}}
        {{else if $value.content_type == '1' && $value.audio_video_list.length > 0}}
            <!--视频-->
            <div class="video _checkoutResourse" data-type="video">
                <div class="logo-box">
                    <div class="audio-btn"></div>
                </div>
                <img src="{{$value.pic_list.origin[0]}}" alt="">
                <!--视频src-->
                <img class="videoSrc" src="{{$value.audio_video_list[0]}}" alt="">
            </div>
        {{else if $value.content_type == '2' && $value.audio_video_list.length > 0}}
            <!--音频-->
            <div class="audio" data-type="audio">
                <audio class="_audioSrc" src="{{$value.audio_video_list[0]}}" controls></audio>
            </div>
        {{/if}}
        {{if $value.sourceWeibo && $value.sourceWeibo.id}}
        {{set sw = $value.sourceWeibo}}
        {{if sw.source_type === 'news'}}
        <div class="dynamin-acticle">
            <a href="/article/detail?id={{sw.id}}">
                <div class="dynamin-acticle-img">
                    <img src="{{sw.logo}}" alt="">
                </div>
                <p>{{sw.content1}}</p>
            </a>
        </div>
        {{else}}
        <div class="comment-level-1">
            <div class="dynamin-list-block">
                <div class="dynamin-content">
                    {{if sw.real_name}}
                    <p class="dynamin-nikeName">
                        <a href="/user/index?uid={{sw.user.uid}}">
                        {{if sw.real_name}}@{{/if}}{{sw.real_name}}
                        </a>
                        <span>{{sw.career}}</span>
                        <!-- <span>{{sw.career}}</span> -->
                    </p>
                    {{/if}}
                    <div class="dynamin-title report-content _msgText">
                        {{@ sw.dealContent}}
                    </div>
                    {{if sw.content_type == '3'}}
                        {{if sw.pic_list && sw.pic_list.origin && sw.pic_list.origin.length > 0 }}
                        {{set imgList = sw.pic_list.origin}}
                        {{set len = imgList.length}}
                        <div class="dynamin-imgs">
                            {{each imgList}}
                            <img class="_smallImg" src="{{$value}}" data-ori-src="{{ imgList[ $index ] }}" alt="">
                           {{/each}}
                        </div>
                        <!--微博图片样式-->
                        <div class="W-image-box">
                            <ul class="fun-bar">
                                <li class="_retract"><i class="icon iconfont icon-shouqi1"></i>收起</li>
                                <!--<li><i class="icon iconfont icon-sousuo1"></i>查看大图</li> -->
                                <li class="_turnRound" data-type="left"><i class="icon iconfont icon-shuaxinzuo"></i>向左旋转</li>
                                <li class="_turnRound" data-type="right"><i class="icon iconfont icon-shuaxin"></i>向右旋转</li>
                            </ul>
                            <div class="bImage-list">
                                <div class="bigimage">
                                    <img src="{{ imgList[0] }}" alt="" class="_activeImgSrc">
                                </div>
                                <div class="toggle-area prev _prevBtn"></div>
                                <div class="toggle-area zoomout _retract"></div>
                                <div class="toggle-area next _nextBtn"></div>
                            </div>
                            {{if len > 1 }}
                            <ul class="sImage-list">
                                {{each imgList}}
                                <li><a href="javascript:;" class="_smallImgList"><img src="{{ imgList[ $index ] }}"></a></li>
                                {{/each}}
                            </ul>
                            {{/if}}
                        </div>
                        <!--微博图片样式end-->
                        {{/if}}
                    {{else if sw.content_type == '1' && sw.audio_video_list.length > 0}}
                        <!--视频-->
                        <div class="video _checkoutResourse" data-type="video">
                            <div class="logo-box">
                                <div class="audio-btn"></div>
                            </div>
                            <img src="{{sw.pic_list.origin[0]}}" alt="">
                            <!--视频src-->
                            <img class="videoSrc" src="{{sw.audio_video_list[0]}}" alt="">
                        </div>
                    {{else if sw.content_type == '2' && sw.audio_video_list.length > 0}}
                        <!--音频-->
                        <div class="audio" data-type="audio">
                            <audio class="_audioSrc" src="{{sw.audio_video_list[0]}}" controls></audio>
                        </div>
                    {{/if}}
                </div>
            </div>
        </div>
        {{/if}}
        {{/if}}
        <div class="dynamin-options padding">
            <input type="hidden" class="_userCurrDymn" value="{{$value.content}}">
            <span class="_thumbBtn {{if $value.is_support}} _hasThumbs {{/if}}" data-id="{{$value.id}}">
                <i class="icon iconfont icon-dianzan {{if $value.is_support}} active {{/if}}"></i>
                <em  data-count="{{$value.support_count}}" class="_currThumbCount">
                    {{if $value.is_support}}
                    取消点赞
                    {{else}}
                    点赞
                    {{/if}}
                    <!-- {{if $value.support_count >0}}
                        {{$value.support_count}}
                    {{else}}
                        点赞
                    {{/if}} -->
                </em>
            </span>
            <span class="_getFirstLevel" data-id="{{$value.id}}">
                <i class="icon iconfont icon-pinglun"></i>
                <em class="_commentCount" data-count="{{$value.comment_count}}">
                {{if $value.comment_count > 0 }}
                   {{$value.comment_count}}条评论
                {{else}}
                添加评论
                {{/if}}
               </em>
            </span>
            <span class="_showTransmitBtn" data-id="{{$value.id}}">
                <i class="icon iconfont icon-zhuanfa"></i>
                {{if $value.repost_count >0}}
                <em class="_reportCount">{{$value.repost_count}}</em>
                {{else}}
                转发
                {{/if}}
            </span>
            {{if !noLastTwoBtn }}
            <span class="_collectBtn {{if $value.collect == 1}} collect {{/if}}" data-id="{{$value.id}}">
                <i class="icon iconfont icon-shoucang"></i>
                <em class="_labelText">
                    {{if $value.collect == 1}}取消收藏{{else}}收藏{{/if}}
                </em>
            </span>
            {{if $value.is_self != "undefined"}}
            {{if $value.is_self == 1}}
            <span class="_deleteDynamicBtn" data-level="1" data-id="{{$value.id}}">
                <i class="icon iconfont icon-shanchu"></i>删除
            </span>
            {{else}}
            <span class="_showReportBtn jubao-box" data-id="{{$value.id}}">
                <i class="icon iconfont icon-jubao"></i>举报
            </span>
           {{/if}}
           {{/if}}
          {{/if}}
        </div>
    </div>
    <div class="dynamin-comment _dynamicReplyContent">
        <div class="dynamin-comment-push _dynamicComment">
        </div>
        <div class="dynamin-list _dynamicFirstList">
        </div>
    </div>
</div>
{{/each}}